import { Box, Flex, Text } from '@chakra-ui/react';
import { CSSProperties, memo } from 'react';

import KeyboardShortcutHint from '@components/common/KeyboardShortcutHint';
import Plus from 'vectors/Plus';
interface Props {
  setFloatingReference: (node: HTMLElement | null) => void;
  floatingStyles: CSSProperties;
  deferredOrgName: string;
  onSave: () => void;
}

const OrgCreateMenu: React.FC<Props> = ({
  setFloatingReference,
  floatingStyles,
  deferredOrgName,
  onSave,
}) => {
  return (
    <Box
      id="create-org-menu"
      ref={setFloatingReference}
      style={floatingStyles}
      w="100%"
      boxShadow="md"
      p={1}
      bgColor="surface.background"
      borderRadius={4}
    >
      <Flex
        flexDirection="row"
        gap={2}
        width="full"
        p={1}
        alignItems="center"
        onClick={onSave}
        cursor="pointer"
        _hover={{ bgColor: 'surface.hover' }}
      >
        <Plus />
        <Flex w="full" overflow="hidden">
          <CreateOrgOption
            label="Create business"
            helperText={deferredOrgName}
            data-testid="create-business"
          />
        </Flex>
        <KeyboardShortcutHint shortcut="enter" />
      </Flex>
    </Box>
  );
};

interface CreateOrgOptionProps {
  label: string;
  helperText: string | null;
  'data-testid': string;
  includeQuotes?: boolean;
}

const CreateOrgOption: React.FC<CreateOrgOptionProps> = memo(
  ({ label, helperText, 'data-testid': dataTestId, includeQuotes = true }) => {
    return (
      <Flex alignItems="center" columnGap={1} width="full" data-testid={dataTestId}>
        <Text flexShrink={0} maxLines={1}>
          {label}
        </Text>
        {helperText != null && (
          <Text
            flexShrink={1}
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            fontWeight="bold"
            minWidth={0}
            overflow="hidden"
          >
            {includeQuotes ? `"${helperText}"` : helperText}
          </Text>
        )}
      </Flex>
    );
  },
);

export default OrgCreateMenu;
